import React from 'react';
import { Section, SectionHeader } from '../ui';

interface StatItem {
  value: number;
  suffix: string;
  label: string;
  icon: string;
}

const stats: StatItem[] = [
  {
    value: 500,
    suffix: '+',
    label: 'Recruiters',
    icon: '/assets/icons/icon_stat_recruiters.webp',
  },
  {
    value: 20,
    suffix: '+',
    label: 'Industries',
    icon: '/assets/icons/icon_stat_industries.webp',
  },
  {
    value: 1000,
    suffix: '+',
    label: 'Candidates delivered',
    icon: '/assets/icons/icon_stat_candidates.webp',
  },
];

function StatCard({ stat }: { stat: StatItem }) {
  return (
    <div className="flex flex-col items-center gap-2 px-4 py-3">
      <img
        src={stat.icon}
        alt=""
        aria-hidden="true"
        width={256}
        height={256}
        loading="lazy"
        decoding="async"
        className="w-12 h-12 object-contain"
      />
      <span className="text-2xl font-bold text-primary tracking-tight">
        {stat.value.toLocaleString()}
        {stat.suffix}
      </span>
      <span className="text-xl text-slate-900 font-medium text-center leading-snug">
        {stat.label}
      </span>
    </div>
  );
}

// eslint-disable-next-line import/prefer-default-export
export function DomainList() {
  const domains = [
    'IT & Tech',
    'Engineering',
    'Finance',
    'Manufacturing',
    'Operations',
    'Aerospace',
    'Marketing',
    'Sales',
    'Staffing',
    'Legal',
    'People & HR',
  ];

  return (
    <Section variant="alternate" className="w-full">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <SectionHeader title="Built for Modern Hiring Teams across Multiple Domains" />
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-slate-700 font-medium text-xl">
          {domains.map((domain, index, array) => (
            <React.Fragment key={domain}>
              <span>{domain}</span>
              {index < array.length - 1 && <span className="text-slate-400 mx-2">•</span>}
            </React.Fragment>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-2xl mx-auto mt-12">
          {stats.map(stat => (
            <StatCard key={stat.label} stat={stat} />
          ))}
        </div>
      </div>
    </Section>
  );
}
